<div class="step-content">
  <app-input-item-selection [formData]="reportTypeConfig"
                            (selectedOption)="onTypeSelect($event)" />
</div>
